/**
 * 设备相关的常量配置
 */

// 设备类型
export const DEVICE_TYPES = [
  { value: 'AIS', label: 'AIS设备' },
  { value: 'CAMERA', label: 'NVR监控' },
  { value: 'RADAR', label: '雷达' },
  { value: 'WATER_LEVEL', label: '水位计' },
  { value: 'LASER', label: '激光测距仪' },
  { value: 'VHF', label: 'VHF设备' },
  { value: 'SCREEN', label: '显示屏' },
  { value: 'RELAY', label: '继电器' },
  { value: 'TENSIONMETER', label: '拉力计' },
  { value: 'VISIBILITY', label: '能见度计' },
  { value: 'ANEMOMETER', label: '风速计' },
  { value: 'FLOWMETER', label: '流速计' },
  { value: 'SENSOR', label: '传感器' },
  { value: 'OTHER', label: '其他设备' }
]

// 设备状态
export const DEVICE_STATUS = {
  ONLINE: {
    value: 'online',
    label: '在线',
    type: 'success'
  },
  OFFLINE: {
    value: 'offline',
    label: '离线',
    type: 'danger'
  },
  WARNING: {
    value: 'warning',
    label: '告警',
    type: 'warning'
  },
  MAINTENANCE: {
    value: 'maintenance',
    label: '维护中',
    type: 'info'
  }
}

// 连接类型
export const CONNECTION_TYPES = [
  { value: 'TCP', label: 'TCP' },
  { value: 'UDP', label: 'UDP' },
  { value: 'SERIAL', label: '串口' },
  { value: 'HTTP', label: 'HTTP' },
  { value: 'RTSP', label: 'RTSP' }
]

// 设备启用状态
export const DEVICE_ENABLED = [
  { value: 1, label: '启用' },
  { value: 0, label: '禁用' }
]

// 设备子类型配置
export const DEVICE_SUBTYPES = {
  AIS: [
    { value: 'default', label: '默认' }
  ],
  CAMERA: [
    { value: 'default', label: '默认' }
  ],
  RADAR: [
    { value: 'ascii', label: 'ASCII' },
    { value: 'binary', label: 'Binary' }
  ],
  WATER_LEVEL: [
    { value: '80G', label: '80G' },
    { value: 'HHD5100', label: 'HHD5100' },
    { value: 'TRWD-30', label: 'TRWD-30' },
    { value: 'ascii', label: 'ASCII' }
  ],
  LASER: [
    { value: 'default', label: '默认' }
  ],
  VHF: [
    { value: 'default', label: '默认' }
  ],
  SCREEN: [
    { value: 'Modbus-RTU', label: 'Modbus-RTU' }
  ],
  RELAY: [
    { value: 'Q2', label: 'Q2' }
  ],
  VISIBILITY: [
    { value: 'default', label: '默认' }
  ],
  ANEMOMETER: [
    { value: 'sm5389b', label: 'SM5389B' },
    { value: 'default', label: '默认' }
  ],
  FLOWMETER: [
    { value: 'default', label: '默认' }
  ],
  TENSIONMETER: [
    { value: 'HX711', label: 'HX711拉力计' }
  ],
  SENSOR: [
    { value: 'default', label: '默认' }
  ],
  OTHER: [
    { value: 'default', label: '默认' }
  ]
} 